import { mapGetters } from 'vuex'
import NtrPaslaugosMap from './../components/ntrpaslaugos/NtrPaslaugosMap'
import busenaNtrTipas from '@/mixins/busenaNtrTipas'

export default {
  mixins: [busenaNtrTipas],
  computed: {
    ...mapGetters([
      'prasymasReadonly',
      'prasymasBusena',
      'prasymasTipas',
      'prasymasTeikejasRole',
      'pagrindasKodas',
    ]),
    rengiamas() {
      return NtrPaslaugosMap['prasymasBusena'].rengiamas.key
    },
    patvirtinti() {
      return NtrPaslaugosMap['prasymasBusena'].patvirtinti.key
    },
    laukiaPatvirtinimo() {
      return NtrPaslaugosMap['prasymasBusena'].laukia_patvirtinimo.key
    },
    laukiaApmokejimo() {
      return NtrPaslaugosMap['prasymasBusena'].laukia_apmokejimo.key
    },
    perduotas() {
      return NtrPaslaugosMap['prasymasBusena'].perduotas.key
    },
    grazintas() {
      return NtrPaslaugosMap['prasymasBusena'].grazintas.key
    },
    nepatikslintas() {
      return NtrPaslaugosMap['prasymasBusena'].nepatikslintas.key
    },
    iregistruotas() {
      return NtrPaslaugosMap['prasymasBusena'].iregistruotas.key
    },
    atmestas() {
      return NtrPaslaugosMap['prasymasBusena'].atmestas.key
    },
    isRengiamas() {
      return this.prasymasBusena === this.rengiamas
    },
    isPatvirtinti() {
      return this.prasymasBusena === this.patvirtinti
    },
    isLaukiaPatvirtinimo() {
      return this.prasymasBusena === this.laukiaPatvirtinimo
    },
    isLaukiaApmokejimo() {
      return this.prasymasBusena === this.laukiaApmokejimo
    },
    isPerduotas() {
      return this.prasymasBusena === this.perduotas
    },
    isGrazintas() {
      return this.prasymasBusena === this.grazintas
    },
    isNepatikslintas() {
      return this.prasymasBusena === this.nepatikslintas
    },
    isIregistruotas() {
      return this.prasymasBusena === this.iregistruotas
    },
    isAtmestas() {
      return this.prasymasBusena === this.atmestas
    },
    isReadonly() {
      return this.prasymasReadonly
    },
    isPrasymasReadonly() {
      return this.prasymasReadonly
    },
    isPrasymasNuomininkas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].nuomininkas.key
      )
    },
    isPrasymasNuomotojas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].nuomotojas.key
      )
    },
    isPrasymasPanaudaDavejas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].panauda_davejas.key
      )
    },
    isPrasymasPanaudaGavejas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].panauda_gavejas.key
      )
    },
    isPrasymasSubnuomininkas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].subnuomininkas.key
      )
    },
    isPrasymasSubnuomotojas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].subnuomotojas.key
      )
    },
    isPrasymasPardavejas() {
      return (
        this.prasymasTeikejasRole ===
        NtrPaslaugosMap['asmuoRole'].pardavejas.key
      )
    },
    isPrasymasPirkejas() {
      return (
        this.prasymasTeikejasRole === NtrPaslaugosMap['asmuoRole'].pirkejas.key
      )
    },
    isSutuoktiniuPrasymu() {
      return this.pagrindasKodas === 'sutuoktiniu_prasymu'
    },
    isNutrukusSantuokai() {
      return this.pagrindasKodas === 'nutrukus_santuokai'
    },
  },
  methods: {
    //
  },
}
